module.exports = __webpack_public_path__ + "img/hb.63cd2f7f.png";